module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1c.90306dcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-1c.svg
// module id = 511
// module chunks = 0